<template>
  <v-snackbar
    v-model="toast.show"
    location="top right"
    :timeout="toast.duration"
    :close-on-back="false"
    :color="color"
  >
    <slot>
      {{ text }}
    </slot>
    <template #actions>
      <v-btn v-if="toast.isClosable" variant="text" @click="toast.show = false">
        {{ t("common.close") }}
      </v-btn>
      <v-icon v-if="toast.type === 'success'">mdi-check</v-icon>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";
import { useToast } from "@/store";
import { computed } from "vue";

const { t } = useI18n();
const toast = useToast();

const color = computed(() => toast.type);
const text = computed(
  () => toast.text || (toast.type === "success" ? t("common.success") : t("common.error")),
);
</script>
